import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {doppeActionTypeLinkView} from "./doppe-action-type-link-view";
import React from 'react';
import {
    doppeLinkSpecIsEntity,
    doppeLinkSpecIsPage,
    doppeLinkSpecIsUrl,
    DoppeLinkSpecEntityType,
} from "../../client-server-common/types/doppe-action-cta-button";
import {DoppeViewerLang} from "../../client-server-common/doppe-viewer/doppe-viewer-lang";
import {
    viewerPageNavigationNavigateToPage,
    viewerPageNavigationNavigateToEntity
} from '../../client-server-common/viewer-pages/viewer-page-navigation/viewer-page-navigation';

export const doppeActionTypeLinkViewViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeLinkView, {
    loadViewerComponents: async () => {
        return {
            DoppeActionTypeLinkViewWidget: (await import('./doppe-action-type-link-view-widget/doppe-action-type-link-view-widget')).DoppeActionTypeLinkViewWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeLinkViewWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeLinkViewWidget
                {...renderProps}
            />
        );

    },

    getActionButtonProps: _actionContext => {
        return {};
    },

    activateCTA: actionContext => {
        const url = actionContext.action.settings.url;
        
        if (doppeLinkSpecIsPage(url)) {
            const pageId = url.pageId;
            if (pageId) {
                actionContext.performContextCallback(async ({clientServices, bymoPageProps}) => {
                    viewerPageNavigationNavigateToPage(pageId, {
                        router: clientServices.viewerRouterClientService,
                        bymoPageProps: bymoPageProps,
                        bymoPageContextProps: actionContext.getBymoPageContextProps(),
                        viewerLang: DoppeViewerLang.English,
                        handleExternalUrl: (externalUrl: string) => {
                            window.location.href = externalUrl;
                        },
                    });
                });
            }
            return;
        }
        
        if (doppeLinkSpecIsEntity(url)) {
            const entityType = url.entityType;
            const entityId = url.entityId;
            if (entityType && entityId) {
                actionContext.performContextCallback(async ({clientServices}) => {
                    viewerPageNavigationNavigateToEntity(entityType as DoppeLinkSpecEntityType, entityId, {
                        router: clientServices.viewerRouterClientService,
                        bymoPageContextProps: actionContext.getBymoPageContextProps(),
                        viewerLang: DoppeViewerLang.English,
                        handleExternalUrl: (externalUrl: string) => {
                            window.location.href = externalUrl;
                        },
                    });
                });
            }
            return;
        }
        
        if (doppeLinkSpecIsUrl(url)) {
            actionContext.navigateToUrl(url, true);
        }
    }
})
